<div class="top-bar-title">
    <div class="top-bar-group">
        <h1>{{title$ | async}}</h1>
    </div>
</div>
